import React, { useState,useEffect } from 'react';
import ArticlePartDatatable from './ArticlePartDatatable';
import ArticlePartModal  from './ArticlePartModal';
import { Button } from 'react-bootstrap';


const BomTab = (props) => {

    
    const [show , setShow]= useState( false );
    const [selectedRecord, setSelectedRecord ] = useState();    
    const [selectedDetailRecord, setSelectedDetailRecord ] = useState();    
    const [checkTime, setCheckTime] = useState(null);
   
    const handleCallback = (id) => {
          setSelectedDetailRecord(id);       
          setShow(true);   
    };
 
    const modalCallback = (isShow) => {             
      setShow(isShow);   
      setCheckTime(Date.now());
      //setDataChanged(dataChanged) ;         
    }

 
    useEffect(() => {      
      setSelectedRecord(props.selectedRecord);
    }, [props.selectedRecord])
  
    return (
      <>
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
        
          <ArticlePartDatatable            
            parentCallback={handleCallback}    
            selectedRecord={selectedRecord}   
            checkTime={checkTime}      
             
          />
          
          <Button
            bsStyle="primary"
          //  bsSize="large"
            className="ml-3 mt-3"
            onClick={() => handleCallback('')} 
          >
            <i class="fas fa-plus"></i>
          </Button>

        </div>

        <ArticlePartModal 
          modal={show}
          parentCallback={modalCallback}
          selectedRecord={selectedDetailRecord}   
          entityId={selectedRecord}         
        /> 

      

       </> 
    );
};

export default BomTab;